import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { TooltipDetalleCoberturaResumenComponent } from '../tooltip-detalle-cobertura-resumen/tooltip-detalle-cobertura-resumen.component';
import { CoberturaResumen, ConsultaSiniestroOutput, Contenido } from 'src/app/models/complementos-web/complementos-web.model';
import { CurrencyPipe, NgClass, SlicePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import { combineLatest, skipWhile, Subscription } from 'rxjs';
import { selectDetalleSiniestroSiniestros, selectObjetoDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { OcultaPaginadorPaginadorDirective } from '../../@directives/ocultar-elemento-paginador.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { PaginaDatosTablaComponent } from '../pagina-datos-tabla/pagina-datos-tabla.component';

@Component({
    selector: 'app-detalle-tabla-coberturas-siniestro-resumen',
    templateUrl: './detalle-tabla-coberturas-siniestro-resumen.component.html',
    styleUrls: ['./detalle-tabla-coberturas-siniestro-resumen.component.scss'],
    imports: [NgClass, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, MatPaginator, OcultaPaginadorPaginadorDirective, MatTooltip, PaginaDatosTablaComponent, SlicePipe, CurrencyPipe]
})
export class DetalleTablaCoberturasSiniestroResumenComponent implements AfterViewInit, OnDestroy {

  @ViewChild('coberturas') paginatorC: MatPaginator;
  @ViewChild('terceros') paginatorT: MatPaginator;

  @Input() ocultarCoberturasTercero: boolean = false;
  @Input() ocultarCoberturasAsegurado: boolean = false;

  @Input() public listCoberturas: MatTableDataSource<any> = new MatTableDataSource([]);
  @Input() public datosTerceros: MatTableDataSource<any> = new MatTableDataSource([]);
  @Input() public estimaciones: any;

  @Output() eventosCoberturasEstimaciones = new EventEmitter<{ nombre: string, valor: any }>();

  // Tabla Coberturas
  public tamanoResultados: number = 0;
  public selectCoberturasDatos = null;
  public selectedCoberturaRowIndex: number = null;

  public displayColumns = ['ClaveCobertura', 'Descripcion', 'Estimacion', 'Deducible', 'PorcDeducible', 'ConDeducible', 'Ver'];

  public siniestroConsultado: string;
  public detalleSiniestroBase: any;
  public detalleSiniestroCompleto: ConsultaSiniestroOutput;
  public listaObservables = new Subscription();

  //Tabla Coberturas terceros
  public tamanoResultadosTercero: number = 0;
  public selectCoberturasDatosTercero = null;
  public selectedCoberturaRowIndexTercero: number = null;

  public paginatorInfo = { pageStart: 0, pageEnd: 0 };
  public displayColumnsTercero = ['TipoTercero', 'Nombre', 'Serie', 'Estatus', 'Importe'];

  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialog,
    private currencyPipe: CurrencyPipe,
    private complementoWebService: ComplementoWebService,
    private procesosComplementoService: ProcesosComunesComplementoService
  ) {
    this.obtenerReduxState();
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.listCoberturas.paginator = this.paginatorC;
    this.datosTerceros.paginator = this.paginatorT;
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleCompleto, detalleBase]) => {
      this.siniestroConsultado = siniestro;
      this.detalleSiniestroCompleto = detalleCompleto;
      this.detalleSiniestroBase = detalleBase;
    });
    this.listaObservables.add(subsComplemento);
  }

  SelectRow(row, tipo: 'COBERTURA' | 'TERCEROS') {
    if (tipo === 'COBERTURA') {
      this.selectedCoberturaRowIndex = row.cve_coberturak;
      this.selectCoberturasDatos = row;
    } else {
      this.selectedCoberturaRowIndexTercero = row.id_tercero;
      this.selectCoberturasDatosTercero = row

    }
  }

  abrirModalDetalleCobertura(elemento, detalleCoberturasResumen?) {
    console.log(this.estimaciones)
    const dialog = this.dialogRef.open(TooltipDetalleCoberturaResumenComponent, {
      width: '450px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: { cobertura: elemento, detalleCoberturasResumen: this.estimaciones?.estimacion ?? this.estimaciones?.Estimacion },
    }).afterClosed().subscribe(data => {

    });
  }

  procesaDeducible(cobertura: CoberturaResumen) {
    let deducible;
    switch (cobertura.cve_coberturak) {
      case 1: case 3: case 5: case 6: case 55: case 70: case 91: case 93:
        switch (cobertura.con_deducible) {
          case 0: case 1:
            deducible = ((cobertura.con_deducible == 0) ? "NO" : "SI");
            break;
          default:
            if (cobertura.deducible > 0) {
              deducible = this.currencyPipe.transform(cobertura.deducible);
            }
        }
        break;

      default:
        return deducible
    }
    return deducible;
  }

  procesaImporte(tercero: Contenido) : string {
    let importe = '';

    switch (tercero.estatus_tercero) {
      case 5: case 6:
        importe = tercero.importe.replace("$", "");
        importe = importe != ".00" ? importe : '';
        break;
      default:
        importe = tercero.importe != ".00" ? importe : '';
        return importe
    }
    return importe;
  }

  guardaEstimaciones() {
    const siniestroFormateado = this.procesosComplementoService.devolverSiniestro(this.siniestroConsultado);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      coberturas: this.generarCadenaCoberturas()
    }

    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.guardaEstimacion(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado != null) {
          this.procesosComplementoService.alertaGeneralComplemento('Guardado', `La información se guardó correctamente`, 'success', false, true);
          this.eventosCoberturasEstimaciones.emit({ nombre: 'ACTUALIZAR_ESTIMACIONES', valor: true });
        } else {
          this.procesosComplementoService.alertaGeneralComplemento('Aviso', `No se pudo guardar la información.`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de las coberturas.' }));
      },
    })
  }

  generarCadenaCoberturas(): string {
    const cadena = this.listCoberturas.data.length ? this.listCoberturas.data.map(cob => {
      const val = cob;
      return `cobertura:${val.cobertura}|importe:${val.importe}|sumaAsegurada:${val.sumaAsegurada}`;
    }).join(',') : "";
    return cadena;
  }

}
